import ViewerRoutes from './ViewerRoutes'

import enhance from './ViewerRoutes.enhancer'

export default enhance(ViewerRoutes)



// WEBPACK FOOTER //
// ./src/App/components/ViewerRoutes/index.js